import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { getSession, useGetAllProfileQuery, useUpdatePrivacyMutation } from '@onesource/services';
import { FC } from 'react';
import { MdLock, MdPublic } from 'react-icons/md';

type TProps = {
  disabled?: boolean;
};

/** Public / Private profile toggle. Saves immediately on click. */
export const AccountPrivacyToggle: FC<TProps> = ({ disabled }) => {
  const token = getSession();
  const { data: profile } = useGetAllProfileQuery({ token });
  const { mutate, isPending } = useUpdatePrivacyMutation();

  const isPrivate = profile?.isPrivate ?? false;
  const isDisabled = !profile || isPending || disabled;

  const handleChange = (nextIsPrivate: boolean) => {
    if (nextIsPrivate !== isPrivate) {
      mutate({ isPrivate: nextIsPrivate });
    }
  };

  return (
    <ButtonGroup variant="outlined" size="small" sx={{ '& .MuiButton-root': { px: 2 } }}>
      <Button
        onClick={() => handleChange(false)}
        variant={isPrivate ? 'outlined' : 'contained'}
        color={isPrivate ? 'inherit' : 'primary'}
        startIcon={<MdPublic size={16} />}
        disabled={isDisabled}
      >
        Public
      </Button>
      <Button
        onClick={() => handleChange(true)}
        variant={isPrivate ? 'contained' : 'outlined'}
        color={isPrivate ? 'error' : 'inherit'}
        startIcon={<MdLock size={16} />}
        disabled={isDisabled}
      >
        Private
      </Button>
    </ButtonGroup>
  );
};
